import { createFileRoute, redirect } from "@tanstack/react-router"
import { buildSignInUrl, isAdminWebAuthSession, loadSession } from "@/app/auth"
import { AppShell } from "@/components/app-shell"

export const Route = createFileRoute("/_authenticated")({
    beforeLoad: async ({ location, preload }) => {
        // Intent preloads are speculative and run again during navigation. Avoid spending auth budget twice.
        if (preload) return

        const session = await loadSession()
        if (!session) throw redirect({ href: buildSignInUrl(location.href), replace: true })
        if (!isAdminWebAuthSession(session)) throw redirect({ to: "/forbidden", replace: true })
        return { session }
    },
    component: AppShell,
})
